@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.insurance-input {
  width: 150px;
  display: flex;
  align-items: center;
}

.error-icon {
  width: 20px;
  height: 30px;

  > svg {
    fill: @multi-package-modal--insurance--fill-color;
    margin-left: 15px;
    height: 30px;
    width: 30px;
    position: relative;
    transform: translateX(-50%) scale(0.55);
  }
}
